import { useTableContext } from "./TableContext";
import { ColumnVisibilityToggle } from "@/components/ColumnVisibilityToggle";

interface TableColumnToggleProps {
  disabled?: boolean;
}

export function TableColumnToggle({ disabled }: TableColumnToggleProps) {
  const { table, loading } = useTableContext();

  return <ColumnVisibilityToggle table={table} disabled={disabled || loading} />;
}
